import { useTheme } from '@mui/material';
import { Chip } from '@shared/components';

interface Props {
  mandatory: boolean;
  label: string;
}

export const MandatoryChip = ({ mandatory, label }: Props) => {
  const theme = useTheme();
  const { status } = theme.vars.palette.semantic;
  const tint = mandatory ? status.positive : status.pending;

  return <Chip label={label} size="small" backgroundColor={tint.soft} textColor={tint.text} />;
};
